<template>
  <div class="container mainOrder" id="mainOrder">
    <left-aslide :activeNum="'1'"></left-aslide>
    <body-layout>
      <template slot="page-header">
        <filter-layout>
          <template slot="filter-left">
            <el-tabs value="first">
              <el-tab-pane label="保函订单" name="first"></el-tab-pane>
            </el-tabs>
          </template>
          <template slot="filter-right">
            <el-input
              v-model="filterForm.keyword"
              @keydown.native.enter="handleSearch"
              placeholder="搜索订单号(项目名称)"
              ><el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button
            ></el-input>
          </template>
        </filter-layout>
      </template>
      <template slot="ebs-content">
        <div class="filters borderRadios" v-loading="loading">
          <ul v-for="(item, index) in screenData" :key="index" class="ulItem">
            <li
              v-for="[key, data] in Object.entries(item)"
              :key="data.n"
              class="liItem"
              @click="
                changeActived(key, index === 0 ? 'applyType' : 'orderStatus')
              "
            >
              <div
                :class="[
                  {
                    isactived:
                      key ===
                      (index === 0
                        ? filterForm['applyType']
                        : filterForm['orderStatus']),
                  },
                ]"
              >
                <span>{{ data.n }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="orderInfoItem">
          <div v-for="item in orderDatas" :key="item.orderNum" class="infoItem">
            <list-card-item :dataList="item"></list-card-item>
          </div>
        </div>
        <div class="order-pagination">
          <el-pagination
            background
            hide-on-single-page
            layout="prev, pager, next"
            :page-size="pagination.size"
            :current-page.sync="pagination.current"
            :total="pagination.total"
            @current-change="handleSearch"
          >
          </el-pagination>
        </div>
      </template>
    </body-layout>
  </div>
</template>

<script>
import listCardItem from './components/listCardItem'
import { queryOrderData } from '@/api/order'
import { ApplyType, GuaranteeApplyStatus,screenData } from '@/shared/type'
import { cloneDeep, pickBy, merge, omit } from 'lodash'

export default {
  name: 'orderListIndex',
  components: {
    listCardItem,
  },
  data() {
    return {
      loading: false,
      screenData: [],
      originOrderList: [],
      pagination: {
        size: 5,
        current: 1,
      },
      filterForm: {
        applyType: '1',
        orderStatus: '1',
        keyword: '',
      },
    }
  },
  computed: {
    isCqsw() {
      return this.$store.state.letter.isCqsw
    },
    orderDatas() {
      return (this.originOrderList || []).map((item) => {
        return {
          ...item,
          guaranteeName: item.isExectronic === '1'?ApplyType[item.applyType]?.n_dz:ApplyType[item.applyType]?.n,
        }
      })
    },
  },
  methods: {
    getDataList() {
      this.loading = true
      try {
        return queryOrderData(
          pickBy(
            merge({}, this.filterForm, this.pagination),
            (v) => v && v !== '1'
          )
        )
          .then((v) => {
            this.loading = false
            const { records, current, size, total } = v?.data
            this.originOrderList = records
            this.pagination = {
              current: current,
              size: size,
              total: total,
            }
          })
          .catch((e) => {
            this.loading = false
          })
      } catch (e) {
        console.warn(e)
      }
    },
    getScreenData() {
      let filteredApplyType = {}
      let filteredApplyStatus = {}
      if (this.isCqsw) {
        Object.keys(ApplyType).forEach(key => {
          if (key !== '8000' && key !== '7000') {
            filteredApplyType[key] = ApplyType[key];
          }
        })
        Object.keys(GuaranteeApplyStatus).forEach(key => {
          if (key !== '4000' && key !== '500') {
            filteredApplyStatus[key] = GuaranteeApplyStatus[key];
          }
        })
      } else {
        filteredApplyType = ApplyType
        filteredApplyStatus = GuaranteeApplyStatus
      }
      const applyStatus = cloneDeep(filteredApplyStatus)
      const applyStatusKeys = Object.keys(applyStatus).filter(
        (item) => /\d+/.test(item) && item !== '4000'
      )
      const applyStatusFilter = applyStatusKeys.reduce((per, cur) => {
        per[cur] = applyStatus[cur]
        return per
      }, {})
      this.screenData = [filteredApplyType, applyStatusFilter]
    },
    handleSearch() {
      this.$nextTick(this.getDataList)
    },
    changeActived(value, key) {
      if(key === 'applyType'){
      screenData(value)
      this.getScreenData()
      }
      this.filterForm[key] = value
      this.getDataList()
    },
  },
  beforeMount() {
    this.getDataList()
    this.getScreenData()
  },
}
</script>

<style scoped>
.container {
  display: flex;
  flex-wrap: nowrap;
  padding-top: 30px;
}
.mainOrder ::v-deep .el-tabs__nav-wrap::after {
  width: 0 !important;
}
.order-pagination {
  margin-bottom: 10px;
  float: right;
}
::v-deep .page-header {
  padding: 0 !important;
}
.mainOrder ::v-deep .el-tabs__header {
  margin: 0 !important;
  bottom: -8px;
}
.mainOrder .filter-layout {
  padding: 8px 30px;
}
.paddingLeft {
  padding: 0 20px;
}
.mainOrder ::v-deep .el-tabs__item {
  font-size: 16px;
  height: 50px;
}
.liItem {
  display: inline-block;
  padding: 11px;
  cursor: pointer;
}
.ulItem {
  border: 1px solid #eeeeee;
  /*padding: 10px;*/
  margin-bottom: 0;
}
.ulItem:nth-child(2) {
  border-top: none !important;
}
.ulItem .liItem:nth-child(1) {
  background-color: #f7fcff;
  border-right: 1px solid #eeeeee;
}
.ulItem .liItem:nth-child(2) {
  /*color: #3B85F4;*/
}
.filters {
  margin-top: 20px;
}
.infoItem {
  background-color: #eff6fa;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  margin: 10px 0;
}
::v-deep .ebs-content {
  padding: 0 20px;
}
.liItem .isactived {
  color: #3b85f4;
}
</style>
